module.exports = "<div class=\"notFound\">\n    <p style=\"color: red;\">Ошибка 404</p>\n    <p>Страница не найдена</p>\n</div>"